export default {
  color: "#08664B",
  shepcolor: "#08664B",
  highlight: "#08664B",
};
